import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {enableUniqueIds} from '@cred/shared/unique-id'
import {Field} from 'redux-form'
import Font from '@cred/react-font'
import {Analytics} from '@cred/react-analytics'
import {emitOnChange} from '@cred/react-analytics/hoc'
import defaultStyles from './themes/default/styles.module.scss'
import credible3 from './themes/credible3/styles.module.scss'
import insider from './themes/insider/styles.module.scss'
import withStyles from '@cred/react-theme'

class Checkbox extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    mobileLabel: PropTypes.string,
    disableFullWidth: PropTypes.bool,
    statusBorder: PropTypes.bool,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    disableFullWidth: false,
    disabled: false,
    statusBorder: false
  }

  constructor(props) {
    super(props)
    enableUniqueIds(this)
    this.analytics = new Analytics(props.analytics)
  }

  render() {
    const {id, className, disableFullWidth, styles = defaultStyles, ...props} = this.props,
      classes = [styles.checkbox, className, !disableFullWidth ? styles.fullWidth : ''].join(' ')

    return (
      <div className={classes}>
        <Field
          type="checkbox"
          component={checkboxInput}
          id={id || this.nextUniqueId()}
          styles={styles}
          {...props}
        />
      </div>
    )
  }
}

const checkboxInput = /*#__PURE__*/ emitOnChange(field =>
  <div onKeyPress={e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      const {input: {checked, onChange}} = field

      onChange(!checked)
    }
  }}>
    <input type="checkbox" id={field.id} {...field.input} disabled={field.disabled}/>
    <Font onClick={field.onClick} element="label" htmlFor={field.id} role="checkbox" tabIndex={0} aria-checked={field.input.checked} className={field.statusBorder ? field.styles.statusBorder : ''}>
      <span className={field.styles.checkboxBox}>
        <span className={field.styles.checkboxIcon}>
          <i className="cred-icon icon-check"/>
        </span>
      </span>
      {field.label &&
        <span className={[field.styles.checkboxLabel, 'hidden-xs', 'hidden-sm'].join(' ')}>
          {field.label}
        </span>
      }
      {(field.mobileLabel || field.label) &&
        <span
          className={[field.styles.checkboxLabel, 'hidden-md', 'hidden-lg', 'hidden-xl'].join(' ')}
        >
          {field.mobileLabel || field.label}
        </span>
      }
    </Font>
  </div>
)

export {Checkbox}

export default /*#__PURE__*/ withStyles(
  credible3, {
    credible: defaultStyles,
    insider,
  }
)(Checkbox)
